import React from 'react';

function ExtraOrderDetails() {
	return (
		<div>
			<div className="d-flex align-items-center mb-2">
							<div>
								<ol className="breadcrumb">
									<li className="breadcrumb-item"><a href="#/">Home</a></li>
									<li className="breadcrumb-item"><a href="#/">Pages</a></li>
									<li className="breadcrumb-item active"></li>
								</ol>
								<h1 className="page-header mb-0">
									Order Details
								</h1>
							</div>
						</div>
						<div className="mb-3 d-md-flex gap-4 fw-bold py-1">
							<div className="mt-md-0 mt-2">
								<a href="#/" className="text-decoration-none d-flex align-items-center gap-2 link-dark">
									<iconify-icon icon="solar:printer-linear" className="fs-4"></iconify-icon>
									Print
								</a>
							</div>
							<div className="mt-md-0 mt-2">
								<a href="#/" className="text-decoration-none d-flex align-items-center gap-2 link-dark">
									<iconify-icon icon="solar:box-linear" className="fs-4"></iconify-icon>
									Restock items
								</a>
							</div>
							<div className="mt-md-0 mt-2">
								<a href="#/" className="text-decoration-none d-flex align-items-center gap-2 link-dark">
									<iconify-icon icon="solar:pen-2-linear" className="fs-4"></iconify-icon>
									Edit
								</a>
							</div>
							<div className="mt-md-0 mt-2">
								<a href="#/" data-bs-toggle="dropdown" className="d-flex align-items-center gap-2 link-dark text-decoration-none">
									<iconify-icon icon="solar:settings-linear" className="fs-4"></iconify-icon>
									More Actions
									<b className="caret ms-0"></b>
								</a>
								<div className="dropdown-menu">
									<a className="dropdown-item" href="#/">Action</a>
									<a className="dropdown-item" href="#/">Another action</a>
									<a className="dropdown-item" href="#/">Something else here</a>
									<div role="separator" className="dropdown-divider"></div>
									<a className="dropdown-item" href="#/">Separated link</a>
								</div>
							</div>
						</div>
						<div className="row gx-4 gy-4">
							<div className="col-xl-8">
								<div className="card border-0 mb-4">
									<div className="card-header bg-none p-3 fs-6 fw-bold gap-2 m-0 d-flex align-items-center">
										<iconify-icon icon="solar:bag-smile-linear" className="fs-4 text-secondary"></iconify-icon>
										Products (3)
										<a href="#/" className="ms-auto text-decoration-none link-dark fw-bold d-flex align-items-center gap-2"><iconify-icon icon="solar:box-linear" className="fs-4 text-body text-opacity-50"></iconify-icon> Add Tracking Link</a>
									</div>
									<div className="card-body p-3">
										<div className="row align-items-center">
											<div className="col-8 d-flex align-items-center gap-3">
												<img src="/color-admin/admin/react/assets/img/product/iphone-17-pro-max.jpg" className="w-80px h-80px rounded-3 object-fit-cover"  alt="" />
												<div className="flex-1">
													<div><a href="#/" className="text-decoration-none link-dark fw-bold">iPhone 17 Pro Max</a></div>
													<div className="fw-semibold text-body text-opacity-50 small">
														SKU: IP17PROMAX-1TB
													</div>
												</div>
											</div>
											<div className="col-2 m-0 ps-lg-3 fw-semibold">
												$1,099 x 1
											</div>
											<div className="col-2 fw-bold m-0 text-end">
												$1,099
											</div>
										</div>
										<hr className="my-3" />
										<div className="row align-items-center">
											<div className="col-8 d-flex align-items-center gap-3">
												<img src="/color-admin/admin/react/assets/img/product/ipad-pro.jpg" className="w-80px h-80px rounded-3 object-fit-cover"  alt="" />
												<div className="flex-1">
													<div className=""><a href="#/" className="text-decoration-none link-dark fw-bold">iPad Pro 2026</a></div>
													<div className="fw-semibold text-body text-opacity-50 small">
														SKU: IPADPRO-1TB
													</div>
												</div>
											</div>
											<div className="col-2 m-0 ps-lg-3 fw-semibold">
												$999 x 1
											</div>
											<div className="col-2 fw-bold m-0 text-end">
												$999
											</div>
										</div>
										<hr className="my-4" />
										<div className="row align-items-center">
											<div className="col-8 d-flex align-items-center gap-3">
												<img src="/color-admin/admin/react/assets/img/product/apple-watch-ultra-3.jpg" className="w-80px h-80px rounded-3 object-fit-cover"  alt="" />
												<div className="flex-1">
													<div className=""><a href="#/" className="text-decoration-none link-dark fw-bold">Apple Watch Ultra 3</a></div>
													<div className="fw-semibold text-body text-opacity-50 small">
														SKU: APPLEWATCHULTRA3
													</div>
												</div>
											</div>
											<div className="col-2 m-0 ps-lg-3 fw-semibold">
												$799 x 1
											</div>
											<div className="col-2 fw-bold m-0 text-end">
												$799
											</div>
										</div>
									</div>
									<div className="card-footer bg-none d-flex p-3">
										<a href="#/" className="btn btn-default ms-auto">More <b className="caret"></b></a>
										<a href="#/" className="btn btn-primary ms-2">Add Tracking</a>
									</div>
								</div>
								<div className="card border-0">
									<div className="card-header bg-none p-3 fs-6 fw-bold gap-2 m-0 d-flex align-items-center">
										<iconify-icon icon="solar:checklist-linear" className="fs-4 text-secondary"></iconify-icon>
										Payment Records
										<a href="#/" className="ms-auto text-decoration-none link-dark fw-bold d-flex align-items-center gap-2"><iconify-icon icon="solar:card-linear" className="fs-4 text-body text-opacity-50"></iconify-icon> View paypal records</a>
									</div>
									<div className="card-body">
										<table className="table table-borderless table-sm fw-semibold m-0">
											<tbody>
												<tr>
													<td className="w-150px">Subtotal</td>
													<td>3 items</td>
													<td className="text-end">$2,897.00</td>
												</tr>
												<tr>
													<td>Tax</td>
													<td>GST 5%</td>
													<td className="text-end">$144.85</td>
												</tr>
												<tr>
													<td>Shipping Fee</td>
													<td>promo code: <u className="text-success">FREESHIPPING</u> (<strike>$120.00</strike>)</td>
													<td className="text-end">$0.00</td>
												</tr>
												<tr>
													<td className="pb-2" colSpan="2"><b>Total</b></td>
													<td className="text-end pb-2 fs-5"><b>$3670.80</b></td>
												</tr>
												<tr>
													<td colSpan="3">
														<hr className="m-0" />
													</td>
												</tr>
												<tr>
														<td className="pt-2 pb-2">
														Paid by customer
													</td>
													<td className="pt-2 pb-2">
														via <a href="#/" className="text-primary text-decoration-none">Paypal</a> (#IRU9589320)
													</td>
													<td className="pt-2 pb-2 text-end">$3041.85</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div className="card-footer bg-none d-flex p-3">
										<a href="#/" className="btn btn-primary ms-auto">Mark as paid</a>
									</div>
								</div>
							</div>
							<div className="col-xl-4">
								<div className="card border-0 mb-4">
									<div className="card-header bg-none p-3 fs-6 fw-bold gap-2 m-0 d-flex align-items-center">
										<iconify-icon icon="solar:clipboard-text-linear" className="fs-4 text-secondary"></iconify-icon>
										Notes
										<a href="#/" className="ms-auto text-decoration-none link-dark fw-bold d-flex align-items-center gap-2"><iconify-icon icon="solar:pen-new-square-linear" className="fs-4 text-body text-opacity-50"></iconify-icon> Edit</a>
									</div>
									<div className="card-body">
										No notes from customer
									</div>
								</div>
								<div className="card border-0 mb-4">
									<div className="card-header bg-none p-3 fs-6 fw-bold gap-2 m-0 d-flex align-items-center">
										<iconify-icon icon="solar:user-id-linear" className="fs-4 text-secondary"></iconify-icon>
										Customer
										<a href="#/" className="ms-auto text-decoration-none link-dark fw-bold d-flex align-items-center gap-2"><iconify-icon icon="solar:pen-new-square-linear" className="fs-4 text-body text-opacity-50"></iconify-icon> Edit</a>
									</div>
									<div className="card-body">
										<div className="d-flex align-items-center">
											<a href="#/" className="d-block"><img src="/color-admin/admin/react/assets/img/user/user-1.jpg" width="45" className="rounded-pill"  alt="" /></a>
											<div className="flex-1 ps-3 lh-sm">
												<a href="#/" className="d-block text-decoration-none link-dark fw-bold mb-1">John Smith</a>
												<span className="fw-semibold text-secondary">johnsmith@gmail.com</span>
											</div>
										</div>
									</div>
								</div>
								<div className="card border-0 mb-4">
									<div className="card-header bg-none p-3 fs-6 fw-bold gap-2 m-0 d-flex align-items-center">
										<iconify-icon icon="solar:scooter-linear" className="fs-4 text-secondary"></iconify-icon>
										Shipping Information
										<a href="#/" className="ms-auto text-decoration-none link-dark fw-bold d-flex align-items-center gap-2"><iconify-icon icon="solar:pen-new-square-linear" className="fs-4 text-body text-opacity-50"></iconify-icon> Edit</a>
									</div>
									<div className="card-body fw-semibold">
										<i className="fas fa-phone fa-fw"></i> +916-663-4289<br /><br />
										867 Highland View Drive<br />
										Newcastle, CA<br />
										California<br />
										95658<br />
										<br />
										<a href="#/" className="btn btn-default btn-sm ps-3 pe-4 rounded-pill"><i className="fa fa-location-dot fa-fw opacity-5 me-1"></i> View map</a>
									</div>
								</div>
								<div className="card border-0 mb-4">
									<div className="card-header bg-none p-3 fs-6 fw-bold gap-2 m-0 d-flex align-items-center">
										<iconify-icon icon="solar:bill-list-linear" className="fs-4 text-secondary"></iconify-icon>
										Billing Information
										<a href="#/" className="ms-auto text-decoration-none link-dark fw-bold d-flex align-items-center gap-2"><iconify-icon icon="solar:pen-new-square-linear" className="fs-4 text-body text-opacity-50"></iconify-icon> Edit</a>
									</div>
									<div className="card-body fw-semibold">
										867 Highland View Drive<br />
										Newcastle, CA<br />
										California<br />
										95658<br />
									</div>
								</div>
							</div>
						</div>
		</div>
	);
}

export default ExtraOrderDetails;
